import { 
    SET_AUDIT_DATES_LIST,
    CREATE_AUDIT_SUCCESS,
    UPDATE_AUDIT_SUCCESS,
    DELETE_AUDIT_SUCCESS
 } from "./AuditDatesTypes";

 const initialState = {
    auditList: [],
    auditCreatedResponse: {},
    auditUpdatedResponse: {},
    isAuditDeleted: "",
 }

 const reducers = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_AUDIT_DATES_LIST:
            return {
                ...state,
                auditList: action.auditList,
            };
        case CREATE_AUDIT_SUCCESS:
            return {
                ...state,
                auditCreatedResponse: action.response,
            }; 
        case UPDATE_AUDIT_SUCCESS:
            return {
                ...state,
                auditUpdatedResponse: action.response,
            };   
        case DELETE_AUDIT_SUCCESS:
            return {
                ...state,
                isAuditDeleted: action.isAuditDeleted,
            };              
        default:
            return state;
    }
}

export default reducers